<template>
    <div>
        <el-row class="search-add" :gutter="15">
            <el-col :span="5">
                <el-input placeholder="设备编号" v-model="dev_id"></el-input>
            </el-col>
            <el-col :span="5">
                <el-input placeholder="被分享机构名称" v-model="to_ins_name"></el-input>
            </el-col>
            <el-col :span="5">
                <el-input placeholder="分享机构名称" v-model="from_ins_name"></el-input>
            </el-col>
            <el-col :span="7">&nbsp;</el-col>
            <el-col :span="2">
                <router-link to="./add">
                    <el-button type="success">新增</el-button>
                </router-link>
            </el-col>
        </el-row>
        <el-row class="search-add" :gutter="15">
            <el-col :span="5">
                <el-date-picker
                    v-model="share_time"
                    type="datetime"
                    value-format="yyyyMMddHHmmss"
                    format="yyyy/MM/dd HH:mm:ss"
                    placeholder="共享日期">
                </el-date-picker>
            </el-col>
            <el-col :span="5">
                <el-date-picker
                    v-model="start_time"
                    type="date"
                    value-format="yyyyMMdd"
                    format="yyyy/MM/dd"
                    placeholder="起始日期">
                </el-date-picker>
            </el-col>
            <el-col :span="5">
                <el-date-picker
                    v-model="end_time"
                    type="date"
                    value-format="yyyyMMdd"
                    format="yyyy/MM/dd"
                    placeholder="截止日期">
                </el-date-picker>
            </el-col>
            <el-col :span="9">
                <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-col>
        </el-row>

        <el-table :data="data" border stripe style="width: 100%">
            <af-table-column prop="devId" label="设备编号">
            </af-table-column>
            <af-table-column prop="share_time" label="共享日期">
            </af-table-column>
            <af-table-column prop="start_time" label="起始日期">
            </af-table-column>
            <af-table-column prop="end_time" label="失效时间">
            </af-table-column>
            <af-table-column prop="toInsName" label="被分享机构名称">
            </af-table-column>
            <af-table-column prop="fromInsName" label="分享机构名称">
            </af-table-column>
            <af-table-column fixed="right" label="操作" width="120">
                <template slot-scope="scope">
                    <el-button @click="Edit(scope.$index)" type="text" size="small">编辑</el-button>
                    <el-button @click="Delete(scope.$index)" type="text" size="small">取消分享</el-button>
                </template>
            </af-table-column>
        </el-table>
        <div class="tableDel-Page">
            <Pagination :params="pagin" @pageBind="getList"></Pagination>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/Pagination';
    export default {
        data() {
            return {
                trem: '',//搜索框
                data: [],
                pagin: {
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                },
                dev_id:'',
                to_ins_name:'',
                from_ins_name:'',
                share_time:'',
                start_time:'',
                end_time:'',
            }
        },
        methods: {
            search() {//搜索
                this.pagin.pageNum = 1;
                this.getList();
            },
            getList() {
                //数据绑定
                let params = {
                    page: this.pagin.pageNum,
                    limit: this.pagin.pageSize,
                }
                if(this.dev_id.trim() !='') {
                    params.dev_id = this.dev_id;
                }
                if(this.to_ins_name.trim() !='') {
                    params.to_ins_name = this.to_ins_name;
                }
                if(this.from_ins_name.trim() !='') {
                    params.from_ins_name = this.from_ins_name;
                }
                if(this.share_time !='') {
                    params.share_time = this.share_time;
                }
                if(this.start_time !='') {
                    params.start_time = this.start_time;
                }
                if(this.end_time !='') {
                    params.end_time = this.end_time;
                }
                this.$http.get('/manage/shared-ins/list', {params:params}).then(({data}) => {
                    this.data = data['data']['records'];
                    this.pagin.total = data['data']['total'];
                });
            },
            Delete(index) {
                //单删
                if(confirm('确认要取消分享吗？')) {
                    let formData = new FormData();
                    formData.append('id',this.data[index].id);
                    this.$http.post('/manage/shared-ins/cancel-sharing',formData).then(() => {
                        this.data.splice(index, 1);
                    })
                }
            },
            Edit(index) {
                this.$store.commit('setEditInfo',this.data[index]);
                this.$router.push('./edit/'+this.data[index].id);
            },
        },
        components: { Pagination }
    }
</script>